import { Illustration, Typography } from "get-life-storybook-ts";
import "./../css/waitingValidation.scss";

// Alta de un comercial (caller) que el cliente abre antes de que el comercial
// guarde la tarjeta (estado `advisor_pending` del gateway, F1 «Caller IT al día»):
// no hay nada que hacer todavía. Sin acciones; el email del comercial le traerá
// de vuelta al cierre. Native es solo IT: copy en italiano sin translations.
export const WAITING_ADVISOR_TITLE = "Il tuo consulente sta completando la tua proposta";
export const WAITING_ADVISOR_BODY =
  "Quando la proposta sarà pronta riceverai un'email per completare la tua polizza: documento d'identità, nota legale, firma e pagamento.";

export default function WaitingAdvisor() {
  return (
    <section className="waitingValidation-section">
      <div className="waitingValidation-illustration">
        <Illustration illustration="ReadingIllustration" height={264} />
      </div>
      <Typography
        variant="H1"
        text={WAITING_ADVISOR_TITLE}
        weight="700"
        className="waitingValidation-title"
      />
      <Typography
        variant="Body"
        weight="400"
        text={WAITING_ADVISOR_BODY}
        className="waitingValidation-body"
      />
    </section>
  );
}
